import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <header className="pc-header">
            <div className="pc-header-container">
                <div className="pc-logo-container">
                    {/* Using the official white logo extracted from the site */}
                    <img
                        src="https://www.peacecorps.gov/static/uswds/img/custom/PeaceCorps-LogoBanner-Wht.5140006fb714.svg"
                        alt="Peace Corps Logo"
                        className="pc-logo"
                    />
                </div>
                <nav className="pc-nav">
                    {/* Simple mock nav items to match the look */}
                    <span className="pc-nav-item">Volunteer</span>
                    <span className="pc-nav-item">Donate</span>
                    <span className="pc-nav-item">About</span>
                </nav>
            </div>
        </header>
    );
};

export default Header;
